import { render, staticRenderFns } from "./MonthlyReports.vue?vue&type=template&id=72ce6de5&"
import script from "./MonthlyReports.vue?vue&type=script&lang=js&"
export * from "./MonthlyReports.vue?vue&type=script&lang=js&"
import style0 from "./MonthlyReports.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VTabItem } from 'vuetify/lib/components/VTabs';
installComponents(component, {VDatePicker,VTabItem})
